import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AwareExposeDashboard from './AwareExposeDashboard';
import AwareExposeCampaigns from './AwareExposeCampaigns';
import NewAwareExposeCampaign from './NewAwareExposeCampaign';
import AwareExposeCampaignDetail from './AwareExposeCampaignDetail';

export default function AwareExposeAdminSection({ companyId }) {
    return (
        <Routes>
            <Route
                path="/"
                element={<AwareExposeDashboard companyId={companyId} />}
            />
            <Route
                path="campaigns"
                element={<AwareExposeCampaigns companyId={companyId} />}
            />
            <Route
                path="campaigns/new"
                element={<NewAwareExposeCampaign companyId={companyId} />}
            />
            <Route
                path="campaigns/:campaignId"
                element={<AwareExposeCampaignDetail companyId={companyId} />}
            />
        </Routes>
    );
}
